import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYaleComponent } from './simple-icons-yale.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYaleComponent ],
    exports:      [ SimpleIconsYaleComponent ],
    bootstrap:    []
})
export class SimpleIconsYaleModule {}
